import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col, Card, Spinner, Table, Alert, Form, Button } from "react-bootstrap";
import { ProductContext } from "../context/AppContext";
import Header from "./Header";
import { Link } from "react-router-dom";
import { all_routes } from "./router/all_routes";
import { DatePicker } from "antd";
import axios from "axios";
import moment from "moment";

const AttendanceMonthly = () => {
    const [attendanceData, setAttendanceData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const { GetstudentData } = useContext(ProductContext);
    const StudentId = GetstudentData?.id;
    const SessionId = GetstudentData?.session;
    const authtoken = localStorage.getItem("token");
const formatDate = (date) => date.toISOString().split("T")[0];

  const [TransportattendanceData, setTransportattendanceData] = useState(null);

  const [MonthattendanceData, setMonthAttendanceData] = useState(null);
  const [MonthfromDate, setMonthFromDate] = useState(new Date());
  const [MonthtoDate, setMonthToDate] = useState(new Date());

    console.log(fromDate, "fromDate15");
    console.log(toDate, "toDate15")

    const fetchAttendanceData = async () => {
        const authtoken = localStorage.getItem("token");

        if (!fromDate || !toDate) {
            alert("Please select both From Date and To Date.");
            return;
        }

        setLoading(true);
        try {
            const response = await axios.get(
                `https://api.mirai.healthcare/api/attendance/StudentAttendance/filter-data`,
                {
                    params: {
                        session_id: SessionId,
                        student_id: StudentId,
                        from_date: fromDate,
                        to_date: toDate,
                    },
                    headers: {
                        "x-auth": authtoken,
                    },
                }
            );
            if (response.data.success) {
                setAttendanceData(response.data.data);
            } else {
                alert("Failed to fetch attendance data.");
            }
        } catch (error) {
            console.error("Error fetching attendance data:", error);
            alert("An error occurred while fetching attendance data.");
        } finally {
            setLoading(false);
        }
    };

   

  const fetchTransportMonthAttendance = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `https://api.mirai.healthcare/api/attendance/StudentAttendance/filter-data?session_id=${SessionId}&student_id=${StudentId}&from_date=${formatDate(MonthfromDate)}&to_date=${formatDate(MonthtoDate)}`,
        { headers: { "x-auth": authtoken } }
      );
      setMonthAttendanceData(res.data);
    } catch (error) {
      console.error("Error fetching monthly attendance:", error);
    } finally {
      setLoading(false);
    }
  };

    console.log(attendanceData, "attendanceData Check Monthly")

  return (
    <div className="page-wrapper">
      <Header />
      <Container fluid className="mt-5" style={{ paddingLeft: "25px", paddingRight: "25px" }}>


        <Card className="mb-4 shadow-sm">
          <Card.Body>
            <h5>Select Date Range</h5>
              <Row className="align-items-end">
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label className="fw-semibold">From Date</Form.Label>
                                <DatePicker
                                    className="form-control"
                                    placeholder="Select Date"
                                    value={fromDate ? moment(fromDate, "DD-MM-YYYY") : null}
                                    onChange={(date) =>
                                        setFromDate(date ? date.format("DD-MM-YYYY") : null)
                                    }
                                    onFocus={() => setFromDate("")}
                                    disabledDate={(current) => current && current > moment().endOf("day")}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label className="fw-semibold">To Date</Form.Label>
                                <DatePicker
                                    className="form-control"
                                    placeholder="Select Date"
                                    value={toDate ? moment(toDate, "DD-MM-YYYY") : null}
                                    onChange={(date) =>
                                        setToDate(date ? date.format("DD-MM-YYYY") : null)
                                    }
                                    onFocus={() => setToDate("")}
                                    disabledDate={(current) => current && current > moment().endOf("day")}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4} className="d-flex align-items-end">
                            <Button variant="primary" onClick={fetchAttendanceData}>
                                Filter
                            </Button>
                        </Col>
                    </Row>
          </Card.Body>
        </Card>



        
            <Card className="shadow-sm">
              <Card.Body>
                <h5 className="mb-3">🗓️ Attendance Records</h5>
                <Row className="justify-content-center">
                            <Col md={8}>
                                <Card className="shadow-sm border rounded-3">
                                    <Card.Body>
                                        <h5 className="fw-bold text-center mb-4">Attendance Summary</h5>
                                        <div className="table-responsive">
                                            <table className="table table-bordered text-center">
                                                <thead className="bg-primary text-white">
                                                    <tr>
                                                        <th>Type</th>
                                                        <th>Count</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className="fw-bold text-primary">Total Days</td>
                                                        <td>{attendanceData?.totalDays}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="fw-bold text-success">Present</td>
                                                        <td>{attendanceData?.present}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="fw-bold text-danger">Absent</td>
                                                        <td>{attendanceData?.absent}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="fw-bold text-warning">Leave</td>
                                                        <td>{attendanceData?.leave}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="fw-bold text-secondary">Not Marked</td>
                                                        <td>{attendanceData?.notMark}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
              </Card.Body>
            </Card>
          
      </Container>
    </div>
  );
};

export default AttendanceMonthly
